import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
var _class;
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var ErrorCategory = /*#__PURE__*/function (ErrorCategory) {
  ErrorCategory["NotFound"] = "NotFound";
  ErrorCategory["NotPermitted"] = "NotPermitted";
  ErrorCategory["MalformedInput"] = "MalformedInput";
  ErrorCategory["Internal"] = "Internal";
  return ErrorCategory;
}({});
export var StatusCode = /*#__PURE__*/function (StatusCode) {
  StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
  StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
  StatusCode[StatusCode["GONE"] = 410] = "GONE";
  StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
  return StatusCode;
}({});
export function isAuthError(error) {
  return isErrorStatusCode(StatusCode.UNAUTHORIZED, error) || isErrorStatusCode(StatusCode.FORBIDDEN, error);
}
export function isErrorStatusCode(statusCode, error) {
  var _error$message;
  if (!error) {
    return false;
  }
  if (error['status'] === statusCode ||
  // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
  error['statusCode'] === statusCode) {
    return true;
  }
  var reg = new RegExp("status (code)?.*(".concat(statusCode, ")"));
  return !!(error !== null && error !== void 0 && (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.match(reg));
}
export function doesErrorContainStatus(statusCode, message) {
  var reg = new RegExp("status .*(".concat(statusCode, ")"));
  return reg.test(message);
}
export var TeamErrorType = /*#__PURE__*/function (TeamErrorType) {
  TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
  return TeamErrorType;
}({});
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
var CommonError = /*#__PURE__*/function (_Error) {
  _inherits(CommonError, _Error);
  var _super = _createSuper(CommonError);
  function CommonError(message) {
    var _this;
    _classCallCheck(this, CommonError);
    _this = _super.call(this, message);
    _this.name = _this.constructor.name;
    _this.message = message || 'UnknownError';
    _this.stack = new Error(message).stack || '';
    return _this;
  }
  return _createClass(CommonError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var DefaultError = /*#__PURE__*/function (_CommonError) {
  _inherits(DefaultError, _CommonError);
  var _super2 = _createSuper(DefaultError);
  function DefaultError(_ref) {
    var _this2;
    var message = _ref.message;
    _classCallCheck(this, DefaultError);
    _this2 = _super2.call(this, message || 'UnknownError');
    Object.setPrototypeOf(_assertThisInitialized(_this2), DefaultError.prototype);
    return _this2;
  }
  return _createClass(DefaultError);
}(CommonError);

/**
 * These errors will not fail UFO experiences
 */
export var SLOIgnoreError = /*#__PURE__*/function (_CommonError2) {
  _inherits(SLOIgnoreError, _CommonError2);
  var _super3 = _createSuper(SLOIgnoreError);
  function SLOIgnoreError(_ref2) {
    var _this3;
    var message = _ref2.message;
    _classCallCheck(this, SLOIgnoreError);
    _this3 = _super3.call(this, "SentryIgnore: ".concat(message || 'UnknownError'));
    Object.setPrototypeOf(_assertThisInitialized(_this3), SLOIgnoreError.prototype);
    return _this3;
  }
  return _createClass(SLOIgnoreError);
}(CommonError);
// Http Errors
export var HttpError = /*#__PURE__*/function (_CommonError3) {
  _inherits(HttpError, _CommonError3);
  var _super4 = _createSuper(HttpError);
  function HttpError(_ref3) {
    var _this4;
    var message = _ref3.message,
      status = _ref3.status,
      traceId = _ref3.traceId,
      path = _ref3.path;
    _classCallCheck(this, HttpError);
    _this4 = _super4.call(this, message);
    Object.setPrototypeOf(_assertThisInitialized(_this4), HttpError.prototype);
    _this4.status = status;
    _this4.traceId = traceId;
    _this4.path = path;
    return _this4;
  }
  return _createClass(HttpError);
}(CommonError);

/**
 * These errors will not fail UFO experiences
 */
export var SLOIgnoreHttpError = /*#__PURE__*/function (_HttpError) {
  _inherits(SLOIgnoreHttpError, _HttpError);
  var _super5 = _createSuper(SLOIgnoreHttpError);
  function SLOIgnoreHttpError(props) {
    var _this5;
    _classCallCheck(this, SLOIgnoreHttpError);
    _this5 = _super5.call(this, props);
    Object.setPrototypeOf(_assertThisInitialized(_this5), SLOIgnoreHttpError.prototype);
    return _this5;
  }
  return _createClass(SLOIgnoreHttpError);
}(HttpError);

// Graphql Errors

export var GraphQLError = /*#__PURE__*/function (_CommonError4) {
  _inherits(GraphQLError, _CommonError4);
  var _super6 = _createSuper(GraphQLError);
  // tslint:disable-line no-any

  function GraphQLError(_ref4) {
    var _this6;
    var message = _ref4.message,
      _ref4$category = _ref4.category,
      category = _ref4$category === void 0 ? 'default' : _ref4$category,
      fields = _ref4.fields;
    _classCallCheck(this, GraphQLError);
    _this6 = _super6.call(this, message);
    Object.setPrototypeOf(_assertThisInitialized(_this6), GraphQLError.prototype);
    _this6.category = category;
    if (fields) {
      _this6.fields = fields;
    }
    return _this6;
  }
  return _createClass(GraphQLError);
}(CommonError);
_class = GraphQLError;
_defineProperty(GraphQLError, "from", function (rawErrors) {
  var firstError = rawErrors[0];
  var errorData = {
    category: firstError.category,
    message: firstError.message
  };
  if (firstError.fields) {
    errorData.fields = firstError.fields.reduce(function (obj, item) {
      obj[item.field] = item.message;
      return obj;
    }, {});
  }
  return new _class(errorData);
});
export function isNetworkError(error) {
  return error && !!error.message && (
  // Firefox
  error.message.includes('NetworkError') ||
  // Chrome
  error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') ||
  // cancel by users or unknown reason
  error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes('отменено') || error.message.includes('Сетевое соединение потеряно.') || error.message.includes('anulowane') || error.message.includes('annulé') || error.message.includes('已取消') || error.message.includes('cancelado') || error.message.includes('キャンセルしました') || error.message.includes('cancelled') || error.message.includes('Network error') ||
  // GraphQL-wrapping network error
  !!(error['graphQLErrors'] && error['networkError']));
}